(ns ui.subscription.core
  (:require [parts.replicant.command :as command]))

(def subscription-query
  {:query/kind :query/subscription})

(def user-session-query
  {:query/kind :query/user-session})

(def ig-accounts-query
  {:query/kind :query/ig-accounts})

(def campaign-query
  {:query/kind :query/campaign-eligible})

(def query-actions
  [[:data/query subscription-query]
   [:data/query user-session-query]
   [:data/query ig-accounts-query]
   [:data/query campaign-query]])

(defn error-message
  "Extracts a human readable error from a command result. Validation errors
   arrive as `{:error \"...\"}`, Paddle API errors as a JSON body with string
   keys."
  [result]
  (when result
    (or (:error result)
        (when-let [error (get result "error")]
          (case (get error "code")
            "subscription_payment_declined"
            "The payment was declined. Please contact your bank/payment provider and try again."

            (str "Payment failed! "
                 (or (get error "detail")
                     "Unknown error. Please contact support.")))))))

(defn command-error
  "The human readable error of the latest run of `command`, or the generic
   `fallback` when the run failed with a shape `error-message` does not know
   (an exception on the server, a network error). Without the fallback such
   a failure would leave the button silent."
  [state command fallback]
  (or (error-message (command/get-latest-result state command))
      (when (command/error? state command)
        fallback)))

(def import-paddle-events-command
  {:command/kind :command/subscription-import-paddle-events
   :command/data {}})

(def import-and-refresh
  [:data/command
   import-paddle-events-command
   {:on-success query-actions}])

(def repeat-import-and-refresh
  ;; Repeats the import of the Paddle event after 3s and 10s, since the Paddle
  ;; events API does not reflect a purchase or quantity adaption immediately.
  [:data/repeat
   [3000 10000]
   [import-and-refresh]])
